module.exports = __webpack_public_path__ + "img/icon-checkmark.cf0c100e.svg";